'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_style2.default);

var APPEARANCE_DEFAULT_SIZES = {
  default: 'md',
  simple: 'md',
  minimal: 'sm',
  string: 'xs'
};

var Notification = function Notification(_ref) {
  var children = _ref.children,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === undefined ? 'default' : _ref$appearance,
      status = _ref.status,
      title = _ref.title,
      size = _ref.size,
      _ref$icon = _ref.icon,
      icon = _ref$icon === undefined ? false : _ref$icon,
      _ref$float = _ref.float,
      float = _ref$float === undefined ? false : _ref$float,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === undefined ? false : _ref$fullWidth,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === undefined ? function () {
    return void 0;
  } : _ref$onClose;
  return _react2.default.createElement(
    'div',
    {
      className: cx('xsui-notification', 'xsui-notification--status-' + status, 'xsui-notification--appearance-' + appearance, 'xsui-notification--size-' + (size || APPEARANCE_DEFAULT_SIZES[appearance]), float && 'xsui-notification--float', fullWidth && 'xsui-notification--full-width') },
    _react2.default.createElement(
      'div',
      { className: cx('xsui-notification__content-wrapper') },
      (icon || appearance === 'simple') && _react2.default.createElement('div', { className: cx('xsui-notification__icon') }),
      _react2.default.createElement(
        'div',
        { className: cx('xsui-notification__message') },
        title && _react2.default.createElement(
          'div',
          { className: cx('xsui-notification__title') },
          title
        ),
        children && _react2.default.createElement(
          'div',
          { className: cx('xsui-notification__entry') },
          children
        )
      )
    ),
    float && _react2.default.createElement(
      'div',
      { className: cx('xsui-notification__close'), onClick: onClose },
      _react2.default.createElement(_icon2.default, { name: 'close', size: 18 })
    )
  );
};

Notification.propTypes = {
  children: function children() {
    return (typeof React$Node === 'function' ? _propTypes2.default.instanceOf(React$Node) : _propTypes2.default.any).apply(this, arguments);
  },
  appearance: _propTypes2.default.oneOf(['default', 'simple', 'minimal', 'string']),
  status: _propTypes2.default.oneOf(['error', 'success', 'warning', 'info']).isRequired,
  title: function title() {
    return (typeof React$Node === 'function' ? _propTypes2.default.instanceOf(React$Node) : _propTypes2.default.any).apply(this, arguments);
  },
  size: _propTypes2.default.oneOf(['xs', 'sm', 'md']),
  icon: _propTypes2.default.bool,
  float: _propTypes2.default.bool,
  fullWidth: _propTypes2.default.bool,
  onClose: _propTypes2.default.func
};
exports.default = Notification;